import { c as _c } from "react/compiler-runtime";
import { Monitor, Tablet, Smartphone } from "lucide-react";
import { CAPABILITY_PANEL } from "@/lib/utils/capabilityWeb.utils";
import CapabilityMiniSite from "./CapabilityMiniSite";
const CapabilityDeviceRail = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex min-w-0 flex-[1.6] flex-col items-center gap-1"><div className="h-16 w-full rounded-md border border-black/10 bg-neutral-100 p-1"><CapabilityMiniSite duration={7} /></div><span className="h-1 w-6 rounded bg-neutral-300" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-14 min-w-0 flex-1 rounded-lg border border-black/10 bg-neutral-100 p-1"><CapabilityMiniSite duration={5.5} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full items-start gap-2">{t0}{t1}<div className="h-16 w-9 shrink-0 rounded-lg border border-black/10 bg-neutral-100 p-1"><CapabilityMiniSite slim={true} duration={4} /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={`${CAPABILITY_PANEL} p-4`}>{t2}<div className="mt-3 flex items-center justify-center gap-3 text-neutral-400"><Monitor size={14} /><Tablet size={14} /><Smartphone size={13} /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default CapabilityDeviceRail;